import { useState, useEffect, useMemo } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import LaGomera from './components/LaGomera';
import HotelOverview from './components/HotelOverview';
import HowToGetThere from './components/HowToGetThere';
import Golf from './components/Golf';
import EcoFinca from './components/EcoFinca';
import Rooms from './components/Rooms';
import Relax from './components/Relax';
import BeachClubLaurel from './components/BeachClubLaurel';
import SportsWellness from './components/SportsWellness';
import PuraVida from './components/PuraVida';
import CuevaParaDos from './components/CuevaParaDos';
import FamilySection from './components/FamilySection';
import B2BSection from './components/B2BSection';
import MediaKit from './components/MediaKit';
import EventsWeddings from './components/EventsWeddings';
import ImportantNotice from './components/ImportantNotice';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import SEOJsonLd from '../../components/base/SEOJsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://meethiszpania.com";

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDarkNav, setIsDarkNav] = useState(false);

  useEffect(() => {
    document.title = "Hotel Jardín Tecina & Tecina Golf - Strefa B2B dla polskich agencji | La Gomera";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "Strefa B2B Hotel Jardín Tecina & Tecina Golf na La Gomerze. Materiały sprzedażowe, wsparcie logistyczne, pakiety golfowe i szybki kontakt dla polskich agencji turystycznych.");
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE_URL}/hotel-jardin-tecina`);

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
      const heroSection = document.getElementById('hero');
      if (heroSection) {
        const heroBottom = heroSection.offsetHeight;
        setIsDarkNav(scrollPosition < heroBottom - 100);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const jsonLd = useMemo(() => ([
    {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      "name": "Hotel Jardín Tecina",
      "url": `${SITE_URL}/hotel-jardin-tecina`,
      "description": "Hotel Jardín Tecina & Tecina Golf – luksusowy hotel na La Gomerze. Strefa B2B dla polskich agencji turystycznych z materiałami sprzedażowymi i wsparciem logistycznym.",
      "image": `${SITE_URL}/og-hotel-jardin.jpg`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Playa de Santiago",
        "addressRegion": "La Gomera",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "28.0916",
        "longitude": "-17.2286"
      },
      "amenityFeature": [
        { "@type": "LocationFeatureSpecification", "name": "Golf Course", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Spa", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Beach Club", "value": true },
        { "@type": "LocationFeatureSpecification", "name": "Restaurant", "value": true }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": "B2B Travel Agencies"
      },
      "inLanguage": "pl"
    },
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "Tecina Golf – La Gomera",
      "url": `${SITE_URL}/hotel-jardin-tecina`,
      "description": "Pole golfowe Tecina Golf na La Gomerze z zapierającymi dech widokami na Atlantyk. Pakiety golfowe dla polskich agencji turystycznych.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Playa de Santiago",
        "addressRegion": "La Gomera",
        "addressCountry": "ES"
      },
      "touristType": ["Golf", "Luxury Tourism", "B2B Travel"]
    }
  ]), []);

  return (
    <div className="min-h-screen">
      <SEOJsonLd data={jsonLd} id="jsonld-hotel-jardin-tecina" />
      <Navigation isScrolled={isScrolled} isDarkNav={isDarkNav} />
      <Hero />
      <ImportantNotice />
      <HotelOverview />
      <Rooms />
      <PuraVida />
      <CuevaParaDos />
      <Golf />
      <EcoFinca />
      <LaGomera />
      <FamilySection />
      <SportsWellness />
      <Relax />
      <BeachClubLaurel />
      <EventsWeddings />
      <B2BSection />
      <MediaKit />
      <HowToGetThere />
      <ContactForm />
      <Footer />
    </div>
  );
}
